import React from "react";
import { Modal, Typography } from "antd";

const { Title, Paragraph, Text } = Typography;

interface ClassesGuideModalProps {
  open: boolean;
  onClose: () => void;
}

const ClassesGuideModal: React.FC<ClassesGuideModalProps> = ({
  open,
  onClose,
}) => (
  <Modal
    title="¿Cómo funcionan las clases?"
    open={open}
    onCancel={onClose}
    footer={null}
    width={640}
  >
    <Typography>
      <Title level={5}>Una clase por grupo</Title>
      <Paragraph>
        Cada fila de esta tabla es un grupo real de la escuela (por ejemplo,
        1° Primaria A). Las asignaturas que ese grupo cursa se muestran como
        etiquetas en la fila. Ya no existe una clase separada por cada
        asignatura.
      </Paragraph>

      <Title level={5}>Agregar o quitar asignaturas</Title>
      <Paragraph>
        El botón <Text italic>Asignaturas</Text> de cada fila abre el panel
        para asociar o retirar asignaturas del grupo. Solo se ofrecen
        asignaturas licenciadas por la escuela para ese grado. Quitar una
        asignatura no borra el contenido histórico: las tareas y evaluaciones
        registradas se conservan.
      </Paragraph>

      <Title level={5}>Alumnos por asignatura</Title>
      <Paragraph>
        De forma predeterminada, todos los alumnos del grupo cursan todas las
        asignaturas. Desde el panel de <Text italic>Asignaturas</Text> se
        puede restringir una asignatura a un subconjunto de alumnos (por
        ejemplo, niveles distintos de inglés).
      </Paragraph>

      <Title level={5}>Profesores</Title>
      <Paragraph>
        El botón <Text italic>Profesores</Text> controla qué asignaturas dicta
        cada profesor en el grupo. Un profesor sin restricciones dicta todas
        las asignaturas del grupo; si se le seleccionan asignaturas
        específicas, solo verá y gestionará esas.
      </Paragraph>

      <Title level={5}>Crear una clase nueva</Title>
      <Paragraph>
        <Text italic>Agregar Clase</Text> crea un grupo nuevo con las
        asignaturas del grado precargadas. Solo puede existir una clase activa
        por escuela, grado y grupo.
      </Paragraph>
    </Typography>
  </Modal>
);

export default ClassesGuideModal;
